import * as Yup from 'yup'

export const CODIGO = 'CtrlEmpresaNotaFiscal'

// Ordem retornada por EmpresaNotaFiscalCaminhadorSQL; a senha não integra a lista.
export const valoresIniciais = (linha = []) => ({
  idEmpresaNotaFiscal: linha[0] ?? null,
  dsRazaoSocial: linha[1] ?? '',
  nrCnpj: linha[2] ?? '',
  idCidadeIbge: linha[3] ?? '',
  acCidadeIbge: linha[3]
    ? [[linha[3]], [linha[3], linha[11]].filter(Boolean).join(' - ')]
    : null,
  dsEmail: linha[4] ?? '',
  nrTelefone: linha[5] ?? '',
  dsPathCertificado: linha[6] ?? '',
  nrSerie: linha[7] ?? '',
  nmSequence: linha[8] ?? '',
  dsSenha: '',
})

export const normalizaCnpj = (valor) => valor.replace(/[./ -]/g, '')

export const cnpjValido = (valor) => {
  const cnpj = normalizaCnpj(valor || '')
  if (!/^\d{14}$/.test(cnpj) || /^(\d)\1{13}$/.test(cnpj)) return false

  const digito = (base, pesos) => {
    const soma = pesos.reduce(
      (total, peso, i) => total + Number(base[i]) * peso,
      0,
    )
    const resto = soma % 11
    return resto < 2 ? 0 : 11 - resto
  }
  const primeiro = digito(
    cnpj.slice(0, 12),
    [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2],
  )
  const segundo = digito(
    cnpj.slice(0, 12) + primeiro,
    [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2],
  )
  return cnpj.endsWith(`${primeiro}${segundo}`)
}

const texto = (limite) =>
  Yup.string().trim().max(limite, `Use no máximo ${limite} caracteres`)

export const esquema = Yup.object({
  dsRazaoSocial: texto(255).required('Informe a razão social'),
  nrCnpj: Yup.string()
    .transform((valor) => normalizaCnpj(valor || ''))
    .test('cnpj-valido', 'Informe um CNPJ válido', cnpjValido)
    .required('Informe o CNPJ'),
  idCidadeIbge: texto(10).required('Informe o código IBGE da cidade'),
  dsEmail: texto(100),
  nrTelefone: texto(20),
  dsPathCertificado: texto(20).required('Informe o caminho do certificado'),
  dsSenha: Yup.string()
    .max(120, 'Use no máximo 120 caracteres')
    .test(
      'senha-obrigatoria',
      'Informe a senha do certificado',
      function (valor) {
        return this.parent.idEmpresaNotaFiscal
          ? !valor || !!valor.trim()
          : !!valor?.trim()
      },
    ),
  nrSerie: Yup.number()
    .transform((valor, original) => (original === '' ? null : valor))
    .nullable()
    .typeError('Informe um número inteiro')
    .integer('Informe um número inteiro')
    .min(-2147483648, 'Número fora do intervalo permitido')
    .max(2147483647, 'Número fora do intervalo permitido'),
  nmSequence: texto(50),
})

export const preparaDados = (valores) => {
  const dados = {
    ...valores,
    nrCnpj: normalizaCnpj(valores.nrCnpj.trim()),
    nrSerie: valores.nrSerie === '' ? null : Number(valores.nrSerie),
  }
  delete dados.acCidadeIbge
  return dados
}
